import http from './http'
import Resource from './resource'
// import FakeResource from './fake-resource'

const path = 'admin/link-promotions'

// class LinkPromotions extends FakeResource {
class LinkPromotions extends Resource {
  constructor(_http) {
    super(path, _http)
  }
}

const LinkPromotionsRequest = new LinkPromotions(http)

export default LinkPromotionsRequest
